import { DislikeIcon, LikeIcon, TrashAltIcon } from "assets/icons";
import { If } from "components";
import { useBoolean } from "hooks";
import moment from "moment";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { IconButton, Modal, PersonInfo, RatingStars } from "ui";

import { useDeleteProductComment } from "../../apis";
import { ProductCommentItemCardProps } from "./ProductCommentItemCard.types";

import styles from "./ProductCommentItemCard.module.scss";

const ProductCommentItemCard = ({
  item,
  refetch
}: ProductCommentItemCardProps) => {
  const { t } = useTranslation();
  const {
    value: isConfirmDeleteModalOpen,
    setTrue: openConfirmDeleteModal,
    setFalse: closeConfirmDeleteModal
  } = useBoolean(false);

  const deleteComment = useDeleteProductComment({
    onSuccess: () => {
      toast.success("Comment deleted successfully!");
      closeConfirmDeleteModal();
      refetch();
    }
  });

  return (
    <div className={styles.comment}>
      <div className={styles.comment_content}>
        <div className={styles.comment_contentHeader}>
          <PersonInfo
            image={item.reseller.image}
            dimensions={{ width: 24, height: 24, borderRadius: "100%" }}
            personName={`${item.reseller.firstname} ${item.reseller.lastname}`}
            nameClassName={styles.comment_resellerName}
          />

          <RatingStars grade={item.grade} size={14} />
        </div>

        <div className={styles.comment_text}>{item.text}</div>
        <If condition={item.image}>
          <a target="_blank" href={item?.image?.url} rel="noreferrer">
            <img src={item?.image?.url} className={styles.comment_image} />
          </a>
        </If>
      </div>

      <div className={styles.comment_dateAndReactions}>
        <div className={styles.comment_date}>
          {moment(item.createdAt).format("MMM D, YYYY")}
        </div>

        <div className={styles.comment_reactions}>
          <div className={styles.comment_reactionContainer}>
            <LikeIcon /> {item.countOfLikes}
          </div>
          <div className={styles.comment_reactionContainer}>
            <DislikeIcon /> {item.countOfDislikes}
          </div>
        </div>
      </div>

      <IconButton
        icon={<TrashAltIcon fill="#FF0033" width={24} height={24} />}
        onClick={openConfirmDeleteModal}
      />

      <If condition={isConfirmDeleteModalOpen}>
        <Modal
          isOpen={isConfirmDeleteModalOpen}
          title={t("Delete comment")}
          isLoading={deleteComment.isLoading}
          okText={t("Confirm")}
          onOk={() => deleteComment.mutate(item.id)}
          contentClassName={styles.comment_confirmModal}
          onClose={closeConfirmDeleteModal}
        >
          <p>{t("Are you sure you want to delete this comment?")}</p>
        </Modal>
      </If>
    </div>
  );
};

export default ProductCommentItemCard;
